export default __webpack_public_path__ + "38c7866d8cff19ff0812710c87b82ddc.webp";